import {
  defaultGapping,
  defaultLayouts,
  GSButton,
  GSImage,
  GSInfoGroup,
  useMediaQuery,
} from "golfstatus_react_components";
import React from "react";
import "./tournament-sponsor-line-item.scss";
import { faCirclePlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import {formatPhoneNumber} from "../../../helpers/Utilities";

const TournamentSponsorLineItem = (props) => {
  const {
    logo,
    name,
    contactName,
    email,
    phone,
    sponsorshipType,
    status,
    tierView,
    editTierView,
    addToTierView,
    sponsorshipTier,
    addSponsorToTier,
    removeSponsor,
  } = props;

  const { isPhone } = useMediaQuery();

  const sponorImageSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: (
          <GSImage src={logo} size={isPhone() ? "wide small" : "wide medium"} />
        ),
      },
    ],
  };

  const firstColumn = {
    sections: [
      {
        ...sponorImageSection,
      },
    ],
  };

  const sponsorInfoSection = {
    sectionItems: [
      {
        type: "primary full-width",
        value: name,
      },
      {
        type: "secondary full-width",
        value: `${
          sponsorshipType === "leaderboard" ? "Technology" : ""
        } Sponsor`,
      },
    ],
  };

  const tierInfoSection = {
    sectionItems: [
      {
        type: "secondary full-width",
        value: `${sponsorshipTier?.name}`,
      },
    ],
  };

  const statusSection = {
    sectionItems: [
      {
        type: "primary",
        value: (
          <GSButton
            title={status}
            type={`secondary pill status ${status}`}
          ></GSButton>
        ),
      },
    ],
  };

  const sponsorContactSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: contactName,
      },
      {
        type: "secondary no-wrap full-width",
        value: email,
      },
    ],
  };
  if (phone && phone !== "") {
    sponsorContactSection.sectionItems.push({
      type: "secondary no-wrap full-width",
      value: formatPhoneNumber(phone),
    });
  }

  const secondColumn = {
    fit: "stretch",
    sections: [
      {
        ...sponsorInfoSection,
      },
      {
        ...sponsorContactSection,
      },
    ],
  };

  const thirdColumn = {
    fit: "stretch",
    sections: [
      {
        ...sponsorInfoSection,
      },
      {
        ...tierInfoSection,
      },
    ],
  };

  const addToTierColumn = {
    fit: "fill",
    sections: [
      {
        sectionItems: [
          {
            type: "primary no-wrap mobile-icon",
            value: (
              <GSButton
                buttonIcon={faCirclePlus}
                type={"light-grey"}
                title={"Add"}
                onClick={() => addSponsorToTier()}
              />
            ),
          },
        ],
      },
    ],
  };

  const statusColumn = {
    sections: [statusSection],
  };

  const getGroup = () => {
    let group = [{ ...firstColumn }, { ...secondColumn }];
    if (tierView || editTierView) {
      group = [{ ...firstColumn }, { ...thirdColumn }];
    }
    if (
      addToTierView &&
      sponsorshipTier?.sponsorshipTierType !== "technology"
    ) {
      group = [{ ...firstColumn }, { ...thirdColumn }, { ...addToTierColumn }];
    }

    if (sponsorshipType === "leaderboard") {
      group.push(statusColumn);
    }
    return group;
  };

  let infoGroup = (
    <GSInfoGroup
      listType="mobile-vertical"
      dataGroups={getGroup()}
      style={{ whiteSpace: "normal" }}
    ></GSInfoGroup>
  );

  if (addToTierView) {
    return (
      <div className="add-to-tier" style={{ overflow: "hidden" }}>
        {infoGroup}
      </div>
    );
  }

  if (editTierView && sponsorshipTier?.sponsorshipTierType === "custom") {
    return (
      <tournament-sponsor-line-item
        style={{ whiteSpace: "normal", overflow: "hidden" }}
      >
        <div
          className="full-width"
          style={{
            ...defaultLayouts.hStack.align("stretch", "center"),
            ...defaultGapping.xLargeGap,
            whiteSpace: "normal",
            overflow: "hidden",
          }}
        >
          {infoGroup}
          {
            <GSButton
              buttonIcon={faTimesCircle}
              onClick={() => removeSponsor()}
            />
          }
        </div>
      </tournament-sponsor-line-item>
    );
  }

  return (
    <tournament-sponsor-line-item style={{ overflow: "hidden" }}>
      {infoGroup}
    </tournament-sponsor-line-item>
  );
};

export default TournamentSponsorLineItem;
